import React from 'react';
import { motion } from 'framer-motion';
import {
  Box,
  HStack,
  Text,
  Button,
  Flex
} from '@chakra-ui/react';
import { MdEdit, MdRefresh } from 'react-icons/md';

const ChatBudgetHeader = ({ budget, style = 'women', onEdit, onReset }) => {
  return (
    <Box className="bg-gradient-to-r from-zinc-50 to-zinc-100 px-6 md:px-8 py-5 border-b border-stone-300">
      <Flex align="center" justify="space-between">
        
        {/* Budget and Style Cards Row */}
        <HStack spacing={{ base: 2, md: 4 }} flex={1} minW={0} maxW={{ base: "70%", md: "80%" }}>
          
          {/* Budget Card */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            className="flex-1"
          >
            <Box 
              className="bg-gradient-to-br from-gray-50 to-blue-50 border border-stone-200 rounded-xl flex items-center gap-2 min-w-0"
              boxShadow="0 2px 8px rgba(59, 130, 246, 0.1)"
              px={{ base: 1, md: 4 }}
              py={{ base: 1, md: 3 }}
            >
              <Text fontSize={{ base: "sm", md: "lg" }}>💰</Text>
              <Box className="flex items-center gap-2 min-w-0">
                <Text 
                  fontSize={{ base: "xs", md: "sm" }}
                  fontWeight="medium"
                  className="text-stone-600"
                  flexShrink={0}
                >
                  Budget
                </Text>
                <Text 
                  fontSize={{ base: "xs", md: "sm" }}
                  fontWeight="bold"
                  className="text-blue-800"
                  noOfLines={1}
                >
                  ${budget?.toLocaleString()}
                </Text>
              </Box>
            </Box>
          </motion.div>

          {/* Style Card */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3, delay: 0.1 }}
            className="flex-1"
          >
            <Box 
              className="bg-gradient-to-br from-gray-50 to-pink-50 border border-stone-200 rounded-xl flex items-center gap-2 min-w-0"
              boxShadow="0 2px 8px rgba(244, 63, 94, 0.1)"
              px={{ base: 1, md: 4 }}
              py={{ base: 1, md: 3 }}
            >
              <Text fontSize={{ base: "sm", md: "lg" }}>👤</Text>
              <Box className="flex items-center gap-2 min-w-0">
                <Text 
                  fontSize={{ base: "xs", md: "sm" }}
                  fontWeight="medium"
                  className="text-stone-600"
                  flexShrink={0}
                >
                  Style
                </Text>
                <Text 
                  fontSize={{ base: "xs", md: "sm" }}
                  fontWeight="bold"
                  className="text-rose-900"
                  noOfLines={1}
                >
                  {style === 'women' ? "Women's" : "Men's"}
                </Text>
              </Box>
            </Box>
          </motion.div>

        </HStack>

        {/* Edit and Reset Buttons */}
        <HStack spacing={{ base: 1, md: 2 }} flexShrink={0}>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: 0.2 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Button
              onClick={onEdit}
              bg="red.700"
              _hover={{ bg: "red.800" }}
              color="white"
              size="sm"
              minH={{ base: "32px", md: "36px" }}
              minW={{ base: "32px", md: "36px" }}
              p={1}
              borderRadius="md"
              aria-label="Edit preferences"
              flexShrink={0}
            >
              <MdEdit size={16} />
            </Button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: 0.3 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Button
              onClick={onReset}
              bg="gray.700"
              _hover={{ bg: "gray.600" }}
              color="white"
              size="sm"
              minH={{ base: "32px", md: "36px" }}
              minW={{ base: "32px", md: "36px" }}
              p={1}
              borderRadius="md"
              aria-label="Reset chat"
              flexShrink={0}
            >
              <MdRefresh size={16} />
            </Button>
          </motion.div>
        </HStack>

      </Flex>
    </Box>
  );
};

export default ChatBudgetHeader;